module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp12_8004.7f165b07.png";